<template>
    <ui-sidebar-float
        :load-text="loadText"
        :load="loading"
        name="users-supervisors-add"
        :title="'Adicionar ' + supervisor"
		:text="`Preencha corretamente os dados do novo ${supervisor.toLowerCase()}.`"

    >
        <div class="sidebar-content">
            <form>
                <ui-input v-model="form.data.first_name" type="text" label="Nome:" size="md" />

                <ui-input v-model="form.data.email" type="text" label="E-mail:" size="md" />

                <ui-input v-model="form.data.password" type="password" label="Senha:" size="md" />

                <ui-team-selector
                    v-model="form.data.team"
                    name="team-selector-supervisors-add"
                />
            </form>

            <div class="box-message">
                <i class="fal fa-envelope-open-text"/> <span>O {{supervisor}} receberá um e-mail com os dados de acesso.</span>
            </div>
        </div>
        <template #footer>
            <ui-button type="button" design="lg success block" @click="submit"> Adicionar {{supervisor}} </ui-button>
        </template>
    </ui-sidebar-float>
</template>

<script>
	import { uiSidebarFloat } from '@/components/ui'
	import { uiTeamSelector } from '@/components/ui-facilita/selectors'
	import { uiButton } from '@/components/ui/buttons'
	import { uiInput, uiSelect2 } from '@/components/ui/form'

	import { team } from '@/services/axios'
	import { storage } from '@/services/storage'

	export default {
		components: {
			uiSidebarFloat,
			uiSelect2,
			uiButton,
			uiInput,
			uiTeamSelector
		},

		data() {
			return {
				supervisor: storage.get('label_supervisor') || 'Supervisor',

				teams: [],

				form: {
					data: {
						first_name: null,
						email: null,
						password: null,
						team: null,
					},
				},
				loadText: null,
				loading: false
			}
		},

		computed: {},

		methods: {
			submit() {
				this.loadText = 'Criando o usuário'
				this.loading = true
				let formData = {
					first_name: this.form.data.first_name,
					email: this.form.data.email,
					password: this.form.data.password,
					user_group: 'supervisor',
				}
				team.
					create(this.form.data.team.id + '/members', formData)
						.then(response => {
							if (response.data && response.data.status !== 'error') {
								if (response.data.msg) this.$toastr.s(response.data.msg)

								this.form.data = {
									first_name: null,
									email: null,
									password: null,
									team: null,
								}
							}else{
								if (response.data && response.data.msg) this.$toastr.e(response.data.msg)
							}
						})
						.catch(error => {
							if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						})
						.finally(() => {
							this.$root.$emit('users-supervisors-search')
							this.loading = false
						})
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
